import { atom } from "jotai";

export interface IPurchaseOrder {
    id?: number;
    po_number?: string | null;
    vendor_po_number?: string | null;
    tracking_link?: string | null;
    vendor_id: string;
    status?: string;
    expected_date?: string | null;
    notes?: string | null;
    created_at?: string;
    updated_at?: string;
    created_by?: number | null;
    updated_by?: number | null;
}

export interface IPurchaseOrderInput extends Omit<IPurchaseOrder, 'id' | 'created_at' | 'updated_at'> {}

export const purchaseOrdersAtom = atom<IPurchaseOrder[]>([]);
export const purchaseOrdersLoadingAtom = atom<boolean>(false);

